import React from 'react'
import PropTypes from 'prop-types'

/** @deprecated */
export const Select = props => {
  const {
    className,
    dataTest,
    defaultText,
    name,
    onChangeHandler,
    options,
    required,
    selected,
  } = props

  const onChange = e => {
    onChangeHandler(options[e.target.value])
  }

  return (
    <select
      data-test={dataTest}
      className={className}
      onChange={onChange}
      required={required}
      name={name}>
      {defaultText && <option value=''>{defaultText}</option>}
      {options.map((o, i) => (
        <option key={o.name || o.label} value={i} selected={o.key === selected}>
          {o.name || o.label}
        </option>
      ))}
    </select>
  )
}

Select.propTypes = {
  onChangeHandler: PropTypes.func,
  className: PropTypes.string,
  defaultText: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  dataTest: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
  selected: PropTypes.string,
}

Select.defaultProps = {
  onChangeHandler: () => {},
  className: '',
  defaultText: null,
  options: [],
  dataTest: '',
  name: '',
  required: false,
  selected: '',
}
